import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SentEmail from './icon-sent-email.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SentEmail {...validProps} />;
}
SvgComponent.iconName = 'iconSentEmail';

/**
 * @deprecated This is a legacy icon
 */
export const SentEmailIcon = svgIconWrapper(SvgComponent);
